// Wetterdaten: Der Player ruft nie selbst das Internet ab (Kap. 15.3). Der Host/Server liefert die Daten
// über einen WeatherProvider (z. B. Player-Endpunkt oder Manifest). On-Prem ohne Internet: kein Provider → Hinweis.
/** Wettercodes von Open-Meteo (WMO) als Symbol und Text. */
export const WEATHER = {
    0: ['☀️', 'Sonnig'], 1: ['🌤️', 'Heiter'], 2: ['⛅', 'Bewölkt'], 3: ['☁️', 'Bedeckt'], 45: ['🌫️', 'Nebel'], 48: ['🌫️', 'Nebel'],
    51: ['🌦️', 'Niesel'], 53: ['🌦️', 'Niesel'], 55: ['🌦️', 'Niesel'], 61: ['🌧️', 'Regen'], 63: ['🌧️', 'Regen'], 65: ['🌧️', 'Starkregen'],
    66: ['🌧️', 'Eisregen'], 67: ['🌧️', 'Eisregen'], 71: ['🌨️', 'Schnee'], 73: ['🌨️', 'Schnee'], 75: ['❄️', 'Starker Schnee'], 77: ['🌨️', 'Schnee'],
    80: ['🌦️', 'Schauer'], 81: ['🌧️', 'Schauer'], 82: ['⛈️', 'Starke Schauer'], 85: ['🌨️', 'Schneeschauer'], 86: ['🌨️', 'Schneeschauer'],
    95: ['⛈️', 'Gewitter'], 96: ['⛈️', 'Gewitter'], 99: ['⛈️', 'Gewitter'],
};
/** Letzter bekannter Stand je Ort (überlebt Folienwechsel, ersetzt den localStorage-Cache des Prototyps). */
const memo = new Map();
export const weatherCache = {
    get: (lat, lon) => memo.get(`${lat},${lon}`),
    set: (lat, lon, d) => void memo.set(`${lat},${lon}`, d),
    clear: () => memo.clear(),
};
/**
 * Provider, der einen Server-Endpunkt abfragt (z. B. GET /api/v1/player/weather?lat=..&lon=..).
 * fetchImpl trägt die Authentifizierung (Bearer) – Token nie in der URL.
 */
export function httpWeatherProvider(baseUrl, fetchImpl) {
    return async ({ lat, lon }) => {
        const sep = baseUrl.includes('?') ? '&' : '?';
        const r = await fetchImpl(`${baseUrl}${sep}lat=${encodeURIComponent(lat)}&lon=${encodeURIComponent(lon)}`);
        if (!r.ok)
            return null;
        return (await r.json());
    };
}
//# sourceMappingURL=weather.js.map